import React, { useState, Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import ReactJson from 'react-json-view';
import {
  Table,
  DateTime,
  Icon,
  TableCell,
  Member
} from 'components/common/Elements/Elements';
import { getInitialsFull } from 'utils/common';

import classes from './ComponentTable.module.scss';

const TableRow = ({ log, tableConf, row, mouseEnter }) => {
  const [idOpenData, setIdOpenData] = useState('');

  const createMember = user => {
    return {
      fullName: user.userFullName ? user.userFullName : 'NA',
      description: user.email ? user.email : 'NA',
      initials: user.userFullName ? getInitialsFull(user.userFullName) : 'NA',
      initialsColor: user.initialsColor ? user.initialsColor : 'NA',
      icon: user.icon ? user.icon : 'NA'
    };
  };
  const parsServiceText = text => {
    return text.slice(0, text.indexOf(':'));
  };
  const handleOpenData = id => {
    id !== idOpenData ? setIdOpenData(id) : setIdOpenData('');
  };

  return (
    <>
      <Table.Row className={classes.row}>
        {tableConf.map(({ title, show, field }, ind) => {
          const cellProps = {
            row: row,
            mouseEnter: mouseEnter,
            ind: ind,
            field: field,
            classes: classes
          };
          return (
            <Fragment key={`${title}-${log._id}}`}>
              {show && field === 'userFullName' && (
                <TableCell cellProps={cellProps}>
                  <Member member={createMember(log)} />
                </TableCell>
              )}
              {show && field === 'service' && (
                <TableCell cellProps={cellProps}>
                  {parsServiceText(log.resource)}
                </TableCell>
              )}
              {show && field === 'resource' && (
                <TableCell cellProps={cellProps}>{log.resource}</TableCell>
              )}
              {show && field === 'action' && (
                <TableCell cellProps={cellProps}>{log.action}</TableCell>
              )}
              {show && field === 'geoData' && (
                <TableCell cellProps={cellProps}>
                  {log.geoData ? log.geoData.ip : 'NA'}
                </TableCell>
              )}
              {show && field === 'datetime' && (
                <TableCell cellProps={cellProps}>
                  {log.datetime ? <DateTime date={log.datetime} time /> : 'NA'}
                </TableCell>
              )}
              {show && field === 'data' && (
                <TableCell cellProps={cellProps}>
                  <Icon
                    size={'32px'}
                    icon="arrow"
                    color="#3a5ba2"
                    onClick={() => handleOpenData(log._id)}
                    className={idOpenData !== log._id ? '' : classes.iconUp}
                  />
                </TableCell>
              )}
            </Fragment>
          );
        })}
      </Table.Row>
      {idOpenData === log._id && (
        <Table.Row>
          <Table.Cell colSpan={7}>
            {typeof log !== 'string' ? (
              <ReactJson
                src={log}
                iconStyle="triangle"
                enableClipboard={false}
                displayDataTypes={false}
                displayObjectSize={false}
                indentWidth={4}
                collapsed={false}
              />
            ) : (
              <p className={classes.textData}>{log}</p>
            )}
          </Table.Cell>
        </Table.Row>
      )}
    </>
  );
};

TableRow.propTypes = {
  log: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
